import { linkifyPlainText as e } from "./utils/linkify-text.mjs";
import { useEffect as t, useRef as n } from "react";
//#region src/extensions/link-extension/use-init-content-with-linkified-text.ts
var r = ({ editor: r, content: i, shouldInitialize: a }) => {
	let o = n(!1);
	t(() => {
		!r || !i || o.current || !a || typeof i != "string" || (r.commands.setContent(e(i)), o.current = !0);
	}, [
		r,
		i,
		a
	]);
};
//#endregion
export { r as useInitContentWithLinkifiedText };
